import Raven from 'raven-js';
class Logger {
  constructor() {
    this.date = new Date().getTime();
    this.delayedErrorsMap = {};
  }
  report(message = '', extra = {}, context = {}, options) {
    const level = options && options.level || 'log';

    // eslint-disable-next-line no-console
    const logger = console[level];
    if (options && options.useNewRelic) {
      console.warn('[forms-utils-lib/logger/Logger] Reporting to New Relic is no longer supported, reporting to Sentry instead.');
    }
    const extraString = (() => {
      try {
        // Stringify so it is a more useful message than [object Object],
        // but do so in try/catch in case of a circular structure.
        return JSON.stringify(extra);
      } catch (_) {
        return extra;
      }
    })();
    this.reportToSentry(message, extra, context);
    logger(`${message} ${extraString} [Reported to Sentry]`);
  }
  reportToSentry(message = '', extra = {}, context = {}) {
    Raven.captureException(new Error(message), Object.assign({}, context, {
      extra
    }));
  }
  getTimestamp() {
    return this.date;
  }
  logServiceError(message = '', xhr = new XMLHttpRequest(), extraMetaData = {}) {
    if (xhr.status === 0) {
      return;
    }
    this.error(`${message}. Status ${xhr.status} ${xhr.statusText}`, Object.assign({
      responseURL: xhr.responseURL,
      responseText: xhr.responseText
    }, extraMetaData));
  }
  error(message = '', extra, options) {
    this.report(message, extra, undefined, Object.assign({}, options, {
      level: 'error'
    }));
  }
  delayedError(key = '', message = '', timeout = 3000, options) {
    try {
      this.clearDelayError(key);
      this.delayedErrorsMap[key] = setTimeout(() => {
        this.report(message, undefined, undefined, options);
      }, timeout);
    } catch (error) {
      this.report('Problem with delayed error', error, undefined, options);
    }
  }
  clearDelayError(key = '') {
    const oldDelayedError = this.delayedErrorsMap[key];
    if (oldDelayedError) {
      clearTimeout(oldDelayedError);
    }
  }
  warn(message = '', extra = {}, options) {
    this.report(message, extra, {
      level: 'warning'
    }, Object.assign({}, options, {
      level: 'warn'
    }));
  }
  log(args) {
    // eslint-disable-next-line no-console
    console.log(args);
  }
  debug(args) {
    // `console.debug` is an alias of `console.log`.
    // eslint-disable-next-line no-console
    console.warn('`Logger.debug` is an alias of `Logger.log`.', 'Please use that instead.');
    this.log(args);
  }
  info(args) {
    // eslint-disable-next-line no-console
    console.info(args);
  }
}
export default new Logger();